import { __awaiter } from "tslib";
import React, { Fragment } from "react";
import { resources } from "../resources";
import { Alert, Button, Typography } from "@mui/material";
import { useAsync } from "react-async-hook";
import { env, fetchCPayPaymentData } from "../request";
export function CPayPayment() {
    const { result, error, loading } = useAsync(() => __awaiter(this, void 0, void 0, function* () {
        const url = window.location.href;
        return fetchCPayPaymentData(env.paymentId, url);
    }), []);
    const messages = resources.getStrings();
    return (React.createElement(Fragment, null,
        loading && React.createElement(Typography, { variant: "body1", align: "center" }, messages.LoadingPayment),
        result && (React.createElement("form", { action: result.url, method: "post", style: { flexGrow: 1 } },
            Object.entries(result.params).map(([key, value]) => (React.createElement("input", { key: key, type: "hidden", name: key, value: value }))),
            React.createElement("input", { type: "hidden", name: "CheckSumHeader", value: result.checksumHeader }),
            React.createElement("input", { type: "hidden", name: "CheckSum", value: result.checksum }),
            React.createElement("input", { type: "hidden", name: "xml_id", value: result.xml_id }),
            React.createElement(Button, { fullWidth: true, type: "submit", variant: "contained", color: "primary", disableElevation: true }, "Pay"))),
        error && React.createElement(Alert, { severity: "error" }, messages.ErrorCodePaymentCreateWalleeMethodError)));
}
//# sourceMappingURL=cpay.js.map